<template lang="html">
  <div class="role-content" v-if="!hasErr">
    <div v-if="userInfo.isDel === 0"></div>
    <div v-else>
      <!-- user_type-用户类型：
	     	0-个人用户
	     	1-育儿顾问：孩子王自己的
		    2-官方运营
		    3-育儿专家：孩子王自己的
		    4-店长：孩子王自己的
		    5-商品专家
		    6-服务主管
		    98-自营月嫂：业务场景没了 
		    99-认证育儿师：open后台入驻的 -->
      <!-- WIKI signType:"1",// 1联营签约月嫂（20210601前的） 2自营签约月嫂(新签约，如20210601后上海新模式) -->
      <!-- 服务端基于签约模式月嫂，细分出 老联营 和 新自营-->
      <!-- signSku有值，isNewYuesao true-->
      <newYuesao v-if="isNewYuesao"></newYuesao>
      <!--认证育儿师-->
      <certifedParenting
        v-else-if="userInfo.worker.userType * 1 === 99"
      ></certifedParenting>
      <!--育儿顾问-->
      <adviserParenting
        v-else-if="userInfo.worker.userType * 1 === 1"
      ></adviserParenting>
      <!--店长-->
      <manager v-else-if="userInfo.worker.userType * 1 === 4"></manager>
      <div v-else></div>
    </div>
  </div>
  <empty v-else text="出错了"></empty>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import newYuesao from '@/components/rear/newYuesao'
import certifedParenting from '@/components/rear/certifiedParenting'
import adviserParenting from '@/components/rear/adviserParenting'
import manager from '@/components/rear/manager'
import empty from '@/components/common/empty'
import { trackView } from './ys_detail_tracker'
import changePrivinceCodeToCityCode from '@/plugins/changeCityCode'
import Cookies from 'js-cookie'

export default {
  data() {
    return {
      uid: null,
      hasErr: false,
      cityId: ''
    }
  },
  async created() {
    this.uid = this.$route.params.uid || this.$$cookie('uid')
    this.setCity()
    await this.getUserInfo()
    const userType = this.userInfo.worker.userType * 1
    if (userType !== 99 && userType !== 1 && userType !== 4) {
      const search = location.search
        .substr(1)
        .replace('&kwtarget=blank', '')
        .replace('kwtarget=blank&', '')
        .replace('kwtarget=blank', '')
      const search_result = search ? `?${search}` : search
      location.replace(`//shequ.cekid.com/bbs/user/${this.uid}${search_result}`)
    }
    if (this.isNewYuesao) {
      this.$$newTrackView({
        bizType: '127',
        pageLevelId: '121013136'
      })
    } else {
      trackView()
    }
  },
  async mounted() {
    this.$$allowRefreshOrShare(true, true)
  },
  methods: {
    setCity() {
      const queryCityCode = this.$route.query.citycode || '' //链接指定
      const selected_city = (this.$$cookie('city_service') || '').split('_')[0] //内部手选
      const citycode = this.$$cookie('citycode') || '' //App传递
      let resultCityCode = ''
      if (queryCityCode) {
        resultCityCode = queryCityCode
      } else if (selected_city) {
        resultCityCode = selected_city
      } else if (citycode) {
        resultCityCode = citycode
      }
      this.cityId = resultCityCode
        ? changePrivinceCodeToCityCode(resultCityCode)
        : ''
      console.log('this.cityId', this.cityId)
    },
    async getUserInfo() {
      try {
        const data = await this.$store.dispatch('getUserInfoData', {
          uid: this.uid,
          cityId: this.cityId,
          memberUid: this.$$cookie('uid')
        })
        if (data.code === '0') {
          this.hasErr = true
          this.$$loading(false)
        } else if (data.code * 1 === 20) {
          // 离职和查不到数据都跳社区
          location.replace(`//shequ.cekid.com/bbs/user/${this.uid}`)
        }
      } catch (e) {
        this.hasErr = true
        this.$$loading(false)
      }
    }
  },
  components: {
    newYuesao,
    certifedParenting,
    adviserParenting,
    manager,
    empty
  },
  computed: {
    ...mapState(['userInfo']),
    isNewYuesao() {
      return (
        this.userInfo &&
        this.userInfo.signSku &&
        this.userInfo.signSku.length != 0
      )
    }
  },
  provide() {
    return {
      /* 咨询顾问事件埋点参数 */
      consultTrackParams: {
        bizType: '127',
        pageLevelId: '121013136',
        clickId: '200001'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.rear-content {
  // padding-top: rem(100px);
}
</style>
